import { ApolloError } from '@apollo/client';
import { CollaboratorsGetCollaborationInviteByIdQuery, useCollaboratorsGetCollaborationInviteByIdQuery } from '@graphql/generated';

export type InviteData = Readonly<CollaboratorsGetCollaborationInviteByIdQuery['getCollaborationInviteById']>;

type GetInviteByIdResult =
  | {
      loading: true;
      data: null;
      error: null;
    }
  | {
      loading: false;
      data?: InviteData;
      error?: ApolloError;
    };

export const useGetInviteById = (inviteId: string): GetInviteByIdResult => {
  const {
    data: dataRaw,
    error,
    loading,
  } = useCollaboratorsGetCollaborationInviteByIdQuery({
    variables: { getCollaborationInviteByIdId: inviteId },
    batchMode: 'fast',
  });

  const data = dataRaw?.getCollaborationInviteById;

  if (loading) {
    return { loading: true, data: null, error: null };
  } else {
    return { loading: false, data, error };
  }
};
